import { Box, Chip } from "@mui/material";
import { ManagementV2 } from "../../containers/pages/CANsense/ManagementV2";
import FeatureErrorBoundary from "../../components/errorBoundary/FeatureErrorBoundary";
import logo from '../../assets/images/stream.png';

function ManagementPage() {
  return (
    <FeatureErrorBoundary featureName="CANsense">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "95vh",
        }}
      >
        {/* Main content area */}
        <Box sx={{ flex: 1, backgroundColor: "transparent" }}>
          <ManagementV2 />
        </Box>

        {/* Footer with Chip */}
        <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
          <Chip
            label="Powered by Stream Data Systems"
            variant="outlined"
            icon={
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{ width: 20, height: 20 }}
              />
            }
          />
        </Box>
      </Box>
    </FeatureErrorBoundary>
  );
}

export default ManagementPage;
